<section class="wrapper">
  @if (isPublicLayout()) {
    <app-public-layout-header></app-public-layout-header>
    <div class="public-layout-wrapper">
      <router-outlet></router-outlet>
      <p class="text-neutral-n6 ps-30 mt-auto pb-10">
        © 2016–{{ currentYear }} TelQ Telecom GmbH. All rights reserved. TelQ® is a registered trademark of TelQ Telecom GmbH, registered in Germany
        and other countries.
      </p>
    </div>
  } @else {
    <app-main-menu *ngIf="userService.isAuth"></app-main-menu>

    <div class="content-wrapper min-vh-100" [ngClass]="{ 'custom-content-wrapper': !userService.isAuth }">
      <div class="container-fluid">
        <ng-container *ngIf="userService.isAuth">
          <div *ngIf="user && user.impersonated" class="d-flex justify-content-between align-items-center mx-30 mt-30 alert alert-warning">
            <div class="d-flex justify-content-start align-items-center gap-10">
              <span class="icon-warning"></span>
              <div class="impersonate-container" *ngIf="user && user.impersonated">
                <strong>Attention!</strong> You are logged in as <strong>{{ user.email }}</strong>
              </div>
            </div>
            <a class="btn btn-sm btn-warning logout-btn" (click)="logout()">Logout</a>
          </div>
        </ng-container>
        <router-outlet></router-outlet>
        <p *ngIf="showCopyrightText && userService.isAuth" class="text-neutral-n6 ps-30">
          © 2016–{{ currentYear }} TelQ Telecom GmbH. All rights reserved. TelQ® is a registered trademark of TelQ Telecom GmbH, registered in
          Germany and other countries.
        </p>
      </div>
    </div>
  }
</section>

<app-offline></app-offline>
<app-notifications-widget></app-notifications-widget>
<app-modals-widget></app-modals-widget>
<app-info></app-info>
<app-update-detect></app-update-detect>
